import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PatchTokenRequest } from './issued-device-management.model';

@Injectable({ providedIn: 'root' })
export class IssuedDeviceManagementResource {
    private readonly baseUrl: string = '/services/apic-issued-device-management/api';

    public constructor(private readonly httpClient: HttpClient) {}

    public patchToken(tokenId: string, patchTokenRequest: PatchTokenRequest): Observable<void> {
        const headers: HttpHeaders = new HttpHeaders().set('Content-Type', 'application/merge-patch+json');

        return this.httpClient.patch<void>(`${this.baseUrl}/tokens/${tokenId}`, patchTokenRequest, {
            headers
        });
    }
}
